import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'
export type AlertType = 'success' | 'danger' | 'warning' | 'info'
export interface AlertMessage {
  message: string
  type: AlertType
}
@Injectable({ providedIn: 'root' })
export class AlertService {
  private messageSubject = new BehaviorSubject<AlertMessage | null>(null)
  // private messageSubject = new Subject<AlertMessage | null>()

  message$ = this.messageSubject.asObservable()

  show(message: string, type: AlertType = 'info') {
    // console.log('service', message)
    this.messageSubject.next({ message, type })
  }

  clear() {
    this.messageSubject.next(null)
  }
}
